var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.cancel()}}},[_c('i',{staticClass:"fa fa-long-arrow-left"}),_vm._v(" "),_c('span',[_vm._v("  Back")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c31eb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/InvoiceScan/Components/back.vue
// module id = OkuY
// module chunks = 12